import { z } from "zod";

import { EMAIL_MESSAGE, MIN_LENGTH_MESSAGE, REQUIRED_MESSAGE } from "@/utils";

export const loginSchema = z.object({
  email: z.string().email({ message: EMAIL_MESSAGE }),
  password: z.string().min(6, { message: MIN_LENGTH_MESSAGE("6") }),
  reCaptchaToken: z.string().optional(),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email({ message: EMAIL_MESSAGE }),
});

export const twoFactorSchema = z.object({
  userId: z.string().uuid({ message: REQUIRED_MESSAGE }),
  email: z.string().email({ message: EMAIL_MESSAGE }),
  passcode: z.string().min(6, { message: MIN_LENGTH_MESSAGE("6") }),
  method: z.enum(["EMAIL", "APP"], { message: REQUIRED_MESSAGE }),
  requirePasscode: z.boolean(),
});
